import { AdhocHoldOfCntrConstant } from "presentation/constant/AdhocHoldOfContainer/AdhocHoldOfCntrConstant";
import { useAdhocHoldOfCntrVM } from "presentation/hook/AdhocHoldOfContainer/useAdhocHoldOfCntrVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useAdhocHoldOfCntrTracked } from "presentation/store/AdhocHoldOfContainer/AdhocHoldOfCntrProvider";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisConfirmModal } from "presentation/view/components/NbisConfirmModal";
import { memo, useMemo, useState } from "react";
import { DialogModal, FieldType, HPHButton, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";

const AdhocHoldReasonModal: React.FC = () => {
    const [adhocHoldOfCntrState] = useAdhocHoldOfCntrTracked();
    const adhocHoldOfCntrVM = useAdhocHoldOfCntrVM();
    const { searchCriteria, selectedRows, reasonCode, isShowReasonPanel } = adhocHoldOfCntrState;
    const SCREEN_CONSTANT = AdhocHoldOfCntrConstant;
    const messageBarVM = useMessageBarVM();
    // const [, setIsLoading] = useState(false);
    const [isShowConfirmModal, setIsShowConfirmModal] = useState<string>("");
    const [isShowConfirmMsg, setIsShowConfirmMsg] = useState<string>("");
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const onHoldClicked = () => {
        let cntrNoList = "";
        selectedRows.forEach(entity => {
            entity.reasonCode = reasonCode;
            if (entity.containerNo) {
                cntrNoList = cntrNoList === "" ? entity.containerNo : cntrNoList + ", " + entity.containerNo;
            }
            cntrNoList = cntrNoList + " ";
        });
        if (!reasonCode) {
            messageBarVM.showError("Before hold container, please select reason code for needed record!");
            return;
        }

        setIsShowConfirmMsg("Container " + cntrNoList + "will be held, are you sure to continue?");
        setIsShowConfirmModal(SCREEN_CONSTANT.TITLE);
    }

    const handleConfirm = () => {
        // setIsLoading(true);
        adhocHoldOfCntrVM.onShowLoading();
        adhocHoldOfCntrVM.onHold(selectedRows).then((data) => {
            if (data && data.success) {
                if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT') {
                    // setIsLoading(false);
                    adhocHoldOfCntrVM.onHideLoading();
                    messageBarVM.showError("Don't successfully call ''Update container hold'' web service of NGEN!");
                } else {
                    messageBarVM.showError("Don't successfully call ''Update container hold'' web service of NGEN!");
                    // messageBarVM.showSuccess("Hold Successfully.");
                }
                adhocHoldOfCntrVM.afterHoldSuccess();
                adhocHoldOfCntrVM.onSearch(searchCriteria).then((data) => {
                    // setIsLoading(false);
                    adhocHoldOfCntrVM.onHideLoading();
                })
            } else {
                // setIsLoading(false);
                adhocHoldOfCntrVM.afterHoldSuccess();
                adhocHoldOfCntrVM.onHideLoading();
                if (data?.data) {
                    messageBarVM.showError(data.data);
                }
            }
        }).catch(error => {
            // setIsLoading(false);
            adhocHoldOfCntrVM.onHideLoading();
            handleCancel();
            messageBarVM.showError(error.msg);
        });

        handleCancel();
    }
    const handleCancel = () => {
        setIsShowConfirmModal("");
        setIsShowConfirmMsg("");
    }

    const memoReasonCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "300px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={reasonCode ?? ''}
                fieldValue={reasonCode}
                fieldLabel={SCREEN_CONSTANT.REASON_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'reasonCode'}
                maxLength={60}
                sort={false}
                options={adhocHoldOfCntrState.dynamicOptions.reasonCodeDropdownOptions}
                requiredFieldList={["reasonCode"]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    adhocHoldOfCntrVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.REASON_CODE, adhocHoldOfCntrState.dynamicOptions.reasonCodeDropdownOptions, adhocHoldOfCntrVM, reasonCode])


    return <><DialogModal style={{ minWidth: '650px', minHeight: '650px' }}
        appendTo='self'
        showButton={false}
        visible={isShowReasonPanel}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">Reason Code</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={adhocHoldOfCntrVM.cancelHoldReasonModal} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className="im-charge-data-search-confirm-modal-content">

                <CriteriaItemContainer>
                    {memoReasonCode}
                </CriteriaItemContainer>

            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                <HPHButton disabled={reasonCode.length === 0} label={'Hold'} size={'Small'} theme={'Primary'} onClick={onHoldClicked} />

            </div>
        }
    />
        <NbisConfirmModal headerText={`${isShowConfirmModal}`}
            contentText={`${isShowConfirmMsg}`}
            visible={isShowConfirmModal ? true : false}
            onCancelClick={handleCancel}
            onCancelLabel={'No'}
            onConfirmClick={handleConfirm}
            onConfirmLabel={'Yes'}
        />
    </>;
};

export default memo(AdhocHoldReasonModal);
